import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { httpFetch, HttpFetch, HttpFetchExtra } from "./fetch";
import { notification } from 'antd';
import { t } from "i18next";
import { CurrentUserContext as uCtx, UserContext } from "./UserContext"

const HttpContext = createContext<HttpFetch>(httpFetch)
export const CurrentUserContext = uCtx;

export const useHttp = () => useContext(HttpContext)
export const useCurrentUser = () => useContext(uCtx)

export function Context(props: { children: ReactNode }) {
    const [[http], setHttp] = useState<HttpFetch[]>([httpFetch])
    const [notifications, contextHolder] = notification.useNotification();
    useEffect(() => {
        notification.config({
            placement: "topRight",
            duration: 5,
            showProgress: true,
            pauseOnHover: true,
        })
    }, [notifications])
    useEffect(() => {
        const http = (url: URL | string, init?: RequestInit, extra?: HttpFetchExtra): Promise<Response> => {
            const r = httpFetch(url, init)
            r.catch((reason) => {
                console.log({ reason })
                notifications.error({ message: "Błąd połączenia", duration: 5, showProgress: true, pauseOnHover: true })
                throw reason
            })
            r.then((res) => {
                if (res.status >= 500) {
                    notifications.error({ message: "Błąd serwera", duration: 5, showProgress: true, pauseOnHover: true })
                } else if (res.status >= 400 && res.status !== 401 && res.status !== 403) {
                    notifications.error({ message: "Coś poszło nie tak", duration: 5, showProgress: true, pauseOnHover: true })
                } else if (res.status === 403) {
                    notifications.error({ message: "Brak uprawnień do operacji", duration: 5, showProgress: true, pauseOnHover: true })
                } else if (res.status >= 200 && res.status <= 299) {
                    if (extra?.successNotification) {
                        notifications.success({ message: t(extra.successNotification), duration: 5, showProgress: true, pauseOnHover: true })
                    }
                }
            })
            return r
        }
        setHttp([http])
    }, [notifications])

    return (

        <HttpContext.Provider value={http}>
            <UserContext>
                {contextHolder}
                {props.children}
            </UserContext>
        </HttpContext.Provider>
    )
}
